import React, { useState } from "react";
import { api } from "@/lib/api";
import { getApiErrorMessage } from "@/lib/apiErrors";
import { toast } from "sonner";

/**
 * Second step of any login flow when the account has TOTP enabled.
 * Exchanges challenge_token + 6-digit code for a real session via
 * /auth/2fa/verify-login and hands the response to onSuccess.
 */
export default function TwoFAPrompt({ challengeToken, onSuccess }) {
  const [code, setCode] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const verify = async () => {
    if (!challengeToken || !code.trim()) return;
    setSubmitting(true);
    try {
      const res = await api.post("/auth/2fa/verify-login", {
        challenge_token: challengeToken,
        code: code.trim(),
      });
      onSuccess(res.data);
    } catch (e) {
      toast.error(getApiErrorMessage(e, "Código 2FA inválido"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="brutal-card bg-white text-ink p-6 w-full max-w-md space-y-3" data-testid="twofa-prompt">
      <div className="overline">STEP · 02</div>
      <h2 className="font-display font-black text-2xl tracking-tight">Verificación 2FA</h2>
      <p className="text-sm text-steel">Introduce el código de 6 dígitos de tu app autenticadora.</p>
      <input
        data-testid="auth-2fa-code"
        value={code}
        onChange={(e) => setCode(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter") verify(); }}
        inputMode="numeric"
        autoFocus
        className="w-full bg-white border-2 border-slate-300 px-3 py-2 min-h-[44px] text-sm focus:border-blueprint focus:outline-none"
        placeholder="123456"
        maxLength={8}
        aria-label="Código de verificación 2FA"
      />
      <button
        data-testid="auth-2fa-submit"
        onClick={verify}
        disabled={submitting || !code.trim()}
        className="w-full bg-ink text-white border-2 border-ink font-bold uppercase tracking-wider px-5 py-2.5 min-h-[44px] disabled:opacity-50 hover:bg-blueprint hover:border-blueprint"
      >
        {submitting ? "Verificando..." : "Verificar y entrar"}
      </button>
    </div>
  );
}
